export default __webpack_public_path__ + "static/media/09.94039438.png";